<style>
#investmentCardModal .v--modal-box.v--modal {
  min-height: 360px !important;
  min-width: 800px !important;
}
#investmentCardModal .v-tabs__div:not(:last-child) {
  padding-right: 5px;
}
#investmentCardModal .v-tabs__div {
  background-image: linear-gradient(
      to bottom,
      rgba(42, 87, 154, 1) 0%,
      rgba(42, 87, 154, 1) 100%
    ),
    linear-gradient(
      to bottom,
      rgba(255, 255, 255, 1) 0%,
      rgba(255, 255, 255, 1) 100%
    );
  background-clip: content-box, padding-box;
}
#investmentCardModal .v-select__selection {
  font-size: 12px !important;
}
#investmentCardModal .v-subheader {
  font-size: 14px !important;
  color: #000 !important;
  font-weight: 600 !important;
}
#investmentCardModal .v-tabs__wrapper--show-arrows {
  margin-left: 0px;
  margin-right: 0px;
}
#investmentCardModal .caption--long {
  display: block;
  max-width: 140px;
}
.btnDisabled {
  pointer-events: none !important;
  color: rgb(136, 136, 136) !important;
}
.btnNoDisplay {
  display: none !important;
}
#investmentCardModal .datepicker--hide {
  pointer-events: none;
}
</style>

<template>
  <Modal
    modalName="investmentCardModal"
    :buttons="['']"
    :editing="editing"
    module="investments"
    :title="`KARTA INWESTYCJI O ID ${investmentData.id}`"
    @opened="loadAllAttachments('investments', 'applications')"
    @closed="close"
    @editingStart="startEditing"
    @editingCancel="cancelEditing"
    @editingSave="saveEditing"
  >
    <div>
      <v-tabs
        color="#2a579a"
        dark
        centered
        grow
        active-class="tab--active"
        :hide-slider="true"
        height="35"
        @change="setCurrentTab"
        v-model="currentTab"
      >
        <v-tab :disabled="editing && currentTab != 0">ATRYBUTY</v-tab>
        <v-tab-item>
          <v-layout row wrap>
            <v-flex xs12>
              <v-subheader>ATRYBUTY INWESTYCJI</v-subheader>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs5>
              <v-select
                :items="statuses"
                v-model="investmentData.status"
                label="Status"
                :append-icon="editing ? '$vuetify.icons.dropdown' : ''"
                :readonly="!editing"
              ></v-select>
            </v-flex>
            <v-spacer />
          </v-layout>

          <v-layout row wrap>
            <v-flex xs12>
              <v-subheader>INFORMACJE O LOKALIZACJI</v-subheader>
            </v-flex>
          </v-layout>

          <v-layout row wrap class="geometry-panel">
            <v-flex
              xs4
              v-if="!investmentData.geometry"
              style="border-right: 1px solid lightgrey;line-height: 50px;display:flex;"
            >
              <v-icon
                class="table__btn--green geometry-panel__add-btn"
                @click="addGeometry"
                :class="{btnDisabled: !editing}"
              >add_circle</v-icon>
              <p
                @click="addGeometry"
                class="hover__pointer"
                :class="{btnDisabled: !editing}"
              >Dodaj geometrię</p>
            </v-flex>
            <v-flex
              xs4
              v-else
              style="border-right: 1px solid lightgrey;line-height: 50px;display:flex;"
              :class="{btnDisabled: !editing}"
            >
              <v-icon
                :class="{btnDisabled: !editing}"
                @click="removeGeometry"
                class="table__btn--red geometry-panel__delete-btn"
              >delete</v-icon>
              <p class="hover__pointer" @click="removeGeometry">Usuń geometrię</p>
            </v-flex>
            <v-flex xs8>
              <v-layout justify-space-between id="geometry-panel">
                <p v-if="investmentData.geometry" class="msg--padding">Geometria dodana</p>
                <p v-else class="msg--padding">Brak dodanej geometrii</p>
                <span v-if="investmentData.geometry">
                  <v-icon
                    title="Przybliż do geometrii"
                    class="geometry-panel__zoom-btn"
                    @click="zoomToInvestmentGeom"
                  >zoom_in</v-icon>
                </span>
              </v-layout>
            </v-flex>
          </v-layout>

          <v-layout row wrap>
            <v-flex xs5>
              <v-text-field
                v-model="investmentData.address_parcel"
                label="Numer działki"
                :readonly="!editing"
              ></v-text-field>
            </v-flex>
            <v-spacer />
            <v-flex xs5>
              <v-text-field
                v-model="investmentData.address_precinct"
                label="Obręb"
                :readonly="!editing"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs5>
              <v-text-field
                v-model="investmentData.address_place"
                label="Miejscowość"
                :readonly="!editing"
              ></v-text-field>
            </v-flex>
            <v-spacer />
            <v-flex xs5>
              <v-text-field
                v-model="investmentData.address_street"
                label="Ulica"
                :readonly="!editing"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs5>
              <v-text-field
                v-model="investmentData.address_order"
                label="Numer"
                :readonly="!editing"
              ></v-text-field>
            </v-flex>
            <v-spacer />
            <v-flex xs5>
              <v-text-field v-model="investmentData.description_investment" label="Opis"></v-text-field>
            </v-flex>
          </v-layout>
        </v-tab-item>

        <v-tab :disabled="editing && currentTab != 1">WNIOSEK</v-tab>
        <v-tab-item>
          <span v-if="!hideInvestmentApp">
            <v-layout row wrap>
              <v-flex xs12>
                <v-subheader>METRYKA DOKUMENTU</v-subheader>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs5>
                <v-text-field
                  v-model="investmentApplication.document_number"
                  label="Numer pisma"
                  :readonly="!editing && isInvestmentAppAdded"
                ></v-text-field>
              </v-flex>
              <v-spacer />
              <v-flex xs5>
                <v-menu
                  v-model="dateMenuInvestmentApp"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :readonly="!editing && isInvestmentAppAdded"
                >
                  <template :readonly="!editing && isInvestmentAppAdded" v-slot:activator="{ on }">
                    <v-text-field
                      v-model="computedDateInvestmentApp"
                      label="Data przyjęcia"
                      prepend-icon="event"
                      :class="{'datepicker--hide': !editing && isInvestmentAppAdded}"
                      :readonly="!editing && isInvestmentAppAdded"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="investmentApplication.document_date"
                    @input="dateMenuInvestmentApp = false"
                    color="#2a579a"
                    no-title
                    :readonly="!editing && isInvestmentAppAdded"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs5>
                <v-text-field
                  v-model="investmentApplication.archive_localization"
                  label="Lokalizacja w archiwum"
                  :readonly="!editing && isInvestmentAppAdded"
                ></v-text-field>
              </v-flex>
              <v-spacer />
              <v-flex xs5>
                <v-select
                  :items="types"
                  v-model="investmentApplication.net_types"
                  label="Typ sieci"
                  :append-icon="(editing || !isInvestmentAppAdded) ? '$vuetify.icons.dropdown' : ''"
                  :readonly="!editing && isInvestmentAppAdded"
                  multiple
                ></v-select>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12>
                <v-text-field
                  v-model="investmentApplication.description"
                  label="Opis inwestycji"
                  :readonly="!editing && isInvestmentAppAdded"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap v-if="!isInvestmentAppAdded">
              <v-spacer />
              <v-flex xs3>
                <v-btn
                  dark
                  color="#304058"
                  @click="addInvestmentDetail('applications')"
                >DODAJ WNIOSEK</v-btn>
              </v-flex>
              <v-spacer />
            </v-layout>
            <v-layout row v-if="isInvestmentAppAdded">
              <v-flex
                xs12
                v-if="$can('read', 'investments_attachments') || $can('edit', 'investments_attachments')"
              >
                <AddAttachment
                  ref="investmentsAppAttach"
                  @attachmentAdded="loadAttachments('investments', 'applications')"
                  @attachmentDeleted="loadAttachments('investments', 'applications')"
                  @confDialogOpened="triggerDialogAttach"
                  :id_="investmentData.id"
                  objectType="investments"
                  objectTable="applications"
                  :auto="true"
                  :module="module"
                />
                <v-subheader class="font--primary">Powiązane załączniki</v-subheader>
                <div
                  v-if="allAttachments['applications'].hasOwnProperty('data') && allAttachments['applications'].data.length > 0"
                >
                  <li
                    class="list__container--el"
                    v-for="(index, key) in allAttachments['applications'].data"
                    :key="key"
                  >
                    <span>{{index.id}} - {{index.filename}}</span>
                    <span>
                      <v-icon
                        @click="downloadAttachment(index.id, index.filename, 'investmentsAppAttach')"
                        small
                        title="Pobierz załącznik"
                        v-if="$can('read', 'investments_attachments') || $can('edit', 'investments_attachments')"
                      >cloud_download</v-icon>
                      <v-icon
                        @click="deleteAttachment(index.id, 'investmentsAppAttach')"
                        small
                        title="Usuń załącznik"
                        v-if="$can('edit', 'investments_attachments')"
                      >delete</v-icon>
                    </span>
                  </li>
                </div>
                <div v-else>
                  <p class="font--primary">Brak powiązanych załączników</p>
                </div>
              </v-flex>
            </v-layout>
          </span>
          <span v-else>
            <v-layout row wrap>
              <v-spacer />
              <v-flex xs4>
                <v-btn
                  dark
                  color="#304058"
                  @click="hideInvestmentApp = false"
                  style="margin-top:50px;margin-left:0"
                >ROZPOCZNIJ DODAWANIE</v-btn>
              </v-flex>
              <v-spacer />
            </v-layout>
          </span>
        </v-tab-item>

        <v-tab :disabled="editing && currentTab != 2" class="caption--long">WARUNKI TECHNICZNE</v-tab>
        <v-tab-item>
          <span v-if="!hideInvestmentPreconditions">
            <v-layout row wrap>
              <v-flex xs12>
                <v-subheader>METRYKA DOKUMENTU</v-subheader>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs5>
                <v-text-field
                  v-model="investmentPrecondition.document_number"
                  label="Numer pisma"
                  :readonly="!editing && isInvestmentPreAdded"
                ></v-text-field>
              </v-flex>
              <v-spacer />
              <v-flex xs5>
                <v-menu
                  v-model="dateMenuInvestmentPre"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :readonly="!editing && isInvestmentPreAdded"
                >
                  <template :readonly="!editing && isInvestmentPreAdded" v-slot:activator="{ on }">
                    <v-text-field
                      v-model="computedDateInvestmentPre"
                      label="Data wydania"
                      :class="{'datepicker--hide': !editing && isInvestmentPreAdded}"
                      prepend-icon="event"
                      :readonly="!editing && isInvestmentPreAdded"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="investmentPrecondition.document_date"
                    @input="dateMenuInvestmentPre = false"
                    color="#2a579a"
                    no-title
                    :readonly="!editing && isInvestmentPreAdded"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12>
                <v-text-field
                  v-model="investmentPrecondition.archive_localization"
                  label="Lokalizacja w archiwum"
                  :readonly="!editing && isInvestmentPreAdded"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex xs12>
                <v-text-field
                  v-model="investmentPrecondition.description"
                  label="Opis"
                  :readonly="!editing && isInvestmentPreAdded"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap v-if="!isInvestmentPreAdded">
              <v-spacer />
              <v-flex xs3>
                <v-btn
                  dark
                  color="#304058"
                  @click="addInvestmentDetail('technical_preconditions')"
                >DODAJ WARUNKI TECHNICZNE</v-btn>
              </v-flex>
              <v-spacer />
            </v-layout>

            <v-layout row v-if="isInvestmentPreAdded">
              <v-flex
                xs12
                v-if="$can('read', 'investments_attachments') || $can('edit', 'investments_attachments')"
              >
                <AddAttachment
                  ref="investmentsPreconditionsAttach"
                  @attachmentAdded="loadAttachments('investments', 'technical_preconditions')"
                  @attachmentDeleted="loadAttachments('investments', 'technical_preconditions')"
                  @confDialogOpened="triggerDialogAttach"
                  :id_="investmentData.id"
                  objectType="investments"
                  objectTable="technical_preconditions"
                  :auto="true"
                  :module="module"
                />
                <v-subheader class="font--primary">Powiązane załączniki</v-subheader>
                <div
                  v-if="allAttachments['technical_preconditions'].hasOwnProperty('data') && allAttachments['technical_preconditions'].data.length > 0"
                >
                  <li
                    class="list__container--el"
                    v-for="(index, key) in allAttachments['technical_preconditions'].data"
                    :key="key"
                  >
                    <span>{{index.id}} - {{index.filename}}</span>
                    <span>
                      <v-icon
                        @click="downloadAttachment(index.id, index.filename, 'investmentsPreconditionsAttach')"
                        small
                        title="Pobierz załącznik"
                        v-if="$can('read', 'investments_attachments') || $can('edit', 'investments_attachments')"
                      >cloud_download</v-icon>
                      <v-icon
                        @click="deleteAttachment(index.id, 'investmentsPreconditionsAttach')"
                        small
                        title="Usuń załącznik"
                        v-if="$can('edit', 'investments_attachments')"
                      >delete</v-icon>
                    </span>
                  </li>
                </div>
                <div v-else>
                  <p class="font--primary">Brak powiązanych załączników</p>
                </div>
              </v-flex>
            </v-layout>
          </span>
          <span v-else>
            <v-layout row wrap>
              <v-spacer />
              <v-flex xs4>
                <v-btn
                  dark
                  color="#304058"
                  @click="hideInvestmentPreconditions = false"
                  style="margin-top:50px;margin-left:0"
                >ROZPOCZNIJ DODAWANIE</v-btn>
              </v-flex>
              <v-spacer />
            </v-layout>
          </span>
        </v-tab-item>

        <v-tab :disabled="editing && currentTab != 3" class="caption--long">DOKUMENTACJA PROJEKTOWA</v-tab>
        <v-tab-item>
          <span v-if="!hideInvestmentDocs">
            <v-layout row wrap>
              <v-flex xs12>
                <v-subheader>METRYKA DOKUMENTU</v-subheader>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs5>
                <v-text-field
                  v-model="investmentDocumentation.document_number"
                  label="Numer pisma"
                  :readonly="!editing && isInvestmentDocAdded"
                ></v-text-field>
              </v-flex>
              <v-spacer />
              <v-flex xs5>
                <v-menu
                  v-model="dateMenuInvestmentDoc"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :readonly="!editing && isInvestmentDocAdded"
                >
                  <template :readonly="!editing && isInvestmentDocAdded" v-slot:activator="{ on }">
                    <v-text-field
                      v-model="computedDateInvestmentDoc"
                      label="Data przyjęcia"
                      :class="{'datepicker--hide': !editing && isInvestmentDocAdded}"
                      prepend-icon="event"
                      :readonly="!editing && isInvestmentDocAdded"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="investmentDocumentation.document_date"
                    @input="dateMenuInvestmentDoc = false"
                    color="#2a579a"
                    no-title
                    :readonly="!editing && isInvestmentDocAdded"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12>
                <v-text-field
                  v-model="investmentDocumentation.archive_localization"
                  label="Lokalizacja w archiwum"
                  :readonly="!editing && isInvestmentDocAdded"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex xs12>
                <v-text-field
                  v-model="investmentDocumentation.description"
                  label="Opis"
                  :readonly="!editing && isInvestmentDocAdded"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap v-if="!isInvestmentDocAdded">
              <v-spacer />
              <v-flex xs3>
                <v-btn
                  dark
                  color="#304058"
                  @click="addInvestmentDetail('documentation')"
                >DODAJ DOKUMENTACJĘ PROJEKTOWĄ</v-btn>
              </v-flex>
              <v-spacer />
            </v-layout>

            <v-layout row v-if="isInvestmentDocAdded">
              <v-flex
                xs12
                v-if="$can('read', 'investments_attachments') || $can('edit', 'investments_attachments')"
              >
                <AddAttachment
                  ref="investmentsDocsAttach"
                  @attachmentAdded="loadAttachments('investments', 'documentation')"
                  @attachmentDeleted="loadAttachments('investments', 'documentation')"
                  @confDialogOpened="triggerDialogAttach"
                  :id_="investmentData.id"
                  objectType="investments"
                  objectTable="documentation"
                  :auto="true"
                  :module="module"
                />
                <v-subheader class="font--primary">Powiązane załączniki</v-subheader>
                <div
                  v-if="allAttachments['documentation'].hasOwnProperty('data') && allAttachments['documentation'].data.length > 0"
                >
                  <li
                    class="list__container--el"
                    v-for="(index, key) in allAttachments['documentation'].data"
                    :key="key"
                  >
                    <span>{{index.id}} - {{index.filename}}</span>
                    <span>
                      <v-icon
                        @click="downloadAttachment(index.id, index.filename, 'investmentsDocsAttach')"
                        small
                        title="Pobierz załącznik"
                        v-if="$can('read', 'investments_attachments') || $can('edit', 'investments_attachments')"
                      >cloud_download</v-icon>
                      <v-icon
                        @click="deleteAttachment(index.id, 'investmentsDocsAttach')"
                        small
                        title="Usuń załącznik"
                        v-if="$can('edit', 'investments_attachments')"
                      >delete</v-icon>
                    </span>
                  </li>
                </div>
                <div v-else>
                  <p class="font--primary">Brak powiązanych załączników</p>
                </div>
              </v-flex>
            </v-layout>
          </span>
          <span v-else>
            <v-layout row wrap>
              <v-spacer />
              <v-flex xs4>
                <v-btn
                  dark
                  color="#304058"
                  @click="hideInvestmentDocs = false"
                  style="margin-top:50px;margin-left:0"
                >ROZPOCZNIJ DODAWANIE</v-btn>
              </v-flex>
              <v-spacer />
            </v-layout>
          </span>
        </v-tab-item>

        <v-tab :disabled="editing && currentTab != 4" class="caption--long">PROCES INWESTYCYJNY</v-tab>
        <v-tab-item>
          <span v-if="!hideInvestmentProc">
            <v-layout row wrap>
              <v-flex xs12>
                <v-subheader>METRYKA DOKUMENTU</v-subheader>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs5>
                <v-text-field
                  v-model="investmentProcess.document_number"
                  label="Numer pisma"
                  :readonly="!editing && isInvestmentProcAdded"
                ></v-text-field>
              </v-flex>
              <v-spacer />
              <v-flex xs5>
                <v-menu
                  v-model="dateMenuInvestmentProc"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :readonly="!editing && isInvestmentProcAdded"
                >
                  <template :readonly="!editing && isInvestmentProcAdded" v-slot:activator="{ on }">
                    <v-text-field
                      v-model="computedDateInvestmentProc"
                      label="Data przyjęcia"
                      :class="{'datepicker--hide': !editing && isInvestmentProcAdded}"
                      prepend-icon="event"
                      :readonly="!editing && isInvestmentProcAdded"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="investmentProcess.document_date"
                    @input="dateMenuInvestmentDoc = false"
                    color="#2a579a"
                    no-title
                    :readonly="!editing && isInvestmentProcAdded"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12>
                <v-text-field
                  v-model="investmentProcess.archive_localization"
                  label="Lokalizacja w archiwum"
                  :readonly="!editing && isInvestmentProcAdded"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex xs12>
                <v-text-field
                  v-model="investmentProcess.description"
                  label="Opis"
                  :readonly="!editing && isInvestmentProcAdded"
                ></v-text-field>
              </v-flex>
            </v-layout>

            <v-layout row wrap>
              <v-flex xs12>
                <v-subheader>POWIĄZANE OBIEKTY</v-subheader>
              </v-flex>
            </v-layout>
            <v-layout row wrap v-if="editing || isInvestmentProcAdded">
              <v-flex xs12>
                <v-btn
                  small
                  dark
                  depressed
                  color="#2a579a"
                  style="margin-left: 0;"
                  @click="selectNewObject"
                >WSKAŻ OBIEKT NA MAPIE</v-btn>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-list subheader style="width: 100%" v-if="objects.length != 0">
                <v-list-tile
                  v-for="(object, index) in objects"
                  :item="object"
                  :key="object.object_id"
                  style="border-bottom: 1px solid lightgrey"
                >
                  <v-list-tile-content>
                    <v-list-tile-title
                      class="font--primary"
                    >Obiekt z warstwy '{{object.full_name}}' - {{object.object_id}}</v-list-tile-title>
                  </v-list-tile-content>

                  <v-list-tile-action>
                    <span>
                      <v-icon
                        depressed
                        fab
                        id="btn__hydrant--zoom"
                        class="hydrant__icon"
                        @click="openObjectCard(object)"
                        title="Otwórz kartę"
                      >note</v-icon>
                      <v-icon
                        depressed
                        fab
                        id="btn__hydrant--zoom"
                        class="hydrant__icon"
                        @click="zoomToObject(object, index)"
                        title="Przybliż do obiektu"
                      >zoom_in</v-icon>
                      <v-icon
                        depressed
                        fab
                        class="hydrant__icon"
                        id="btn__hydrant--remove"
                        v-if="editing"
                        @click="removeObject(object, index)"
                        title="Usuń obiekt"
                      >delete</v-icon>
                    </span>
                  </v-list-tile-action>
                </v-list-tile>
              </v-list>
              <v-flex v-else>
                <p
                  v-if="objects.length == 0"
                  style="font-size: 12px; margin-bottom:20px"
                >Brak zaznaczonych obiektów. Kliknij przycisk powyżej, a następnie wskaż na mapie obiekt, do którego chciałbyś dodać załącznik.</p>
              </v-flex>
            </v-layout>

            <v-layout row wrap v-if="!isInvestmentProcAdded">
              <v-spacer />
              <v-flex xs4>
                <v-btn
                  dark
                  color="#304058"
                  @click="addInvestmentDetail('process')"
                >DODAJ PROCES INWESTYCYJNY</v-btn>
              </v-flex>
              <v-spacer />
            </v-layout>

            <v-layout row v-if="isInvestmentProcAdded">
              <v-flex
                xs12
                v-if="$can('read', 'investments_attachments') || $can('edit', 'investments_attachments')"
              >
                <AddAttachment
                  ref="investmentsProcessAttach"
                  @attachmentAdded="loadAttachments('investments', 'process')"
                  @attachmentDeleted="loadAttachments('investments', 'process')"
                  @confDialogOpened="triggerDialogAttach"
                  :id_="investmentData.id"
                  objectType="investments"
                  objectTable="process"
                  :auto="true"
                  :module="module"
                />
                <v-subheader class="font--primary">Powiązane załączniki</v-subheader>
                <div
                  v-if="allAttachments['process'].hasOwnProperty('data') && allAttachments['process'].data.length > 0"
                >
                  <li
                    class="list__container--el"
                    v-for="(index, key) in allAttachments['process'].data"
                    :key="key"
                  >
                    <span>{{index.id}} - {{index.filename}}</span>
                    <span>
                      <v-icon
                        @click="downloadAttachment(index.id, index.filename, 'investmentsProcessAttach')"
                        small
                        title="Pobierz załącznik"
                        v-if="$can('read', 'investments_attachments') || $can('edit', 'investments_attachments')"
                      >cloud_download</v-icon>
                      <v-icon
                        @click="deleteAttachment(index.id, 'investmentsProcessAttach')"
                        small
                        title="Usuń załącznik"
                        v-if="$can('edit', 'investments_attachments')"
                      >delete</v-icon>
                    </span>
                  </li>
                </div>
                <div v-else>
                  <p class="font--primary">Brak powiązanych załączników</p>
                </div>
              </v-flex>
            </v-layout>
          </span>
          <span v-else>
            <v-layout row wrap>
              <v-spacer />
              <v-flex xs4>
                <v-btn
                  dark
                  color="#304058"
                  @click="hideInvestmentProc = false"
                  style="margin-top:50px;margin-left:0"
                >ROZPOCZNIJ DODAWANIE</v-btn>
              </v-flex>
              <v-spacer />
            </v-layout>
          </span>
        </v-tab-item>

        <v-tab :disabled="editing && currentTab != 5">ODBIORY</v-tab>
        <v-tab-item>
          <span v-if="!hideInvestmentAcc">
            <v-layout row wrap>
              <v-flex xs12>
                <v-subheader>METRYKA DOKUMENTU</v-subheader>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs5>
                <v-menu
                  v-model="dateMenuInvestmentAccStart"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :readonly="!editing && isInvestmentAccAdded"
                >
                  <template :readonly="!editing && isInvestmentAccAdded" v-slot:activator="{ on }">
                    <v-text-field
                      v-model="computedDateInvestmentAccStart"
                      label="Data rozpoczęcia"
                      :class="{'datepicker--hide': !editing && isInvestmentAccAdded}"
                      prepend-icon="event"
                      :readonly="!editing && isInvestmentAccAdded"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="investmentAcceptance.date_from"
                    @input="dateMenuInvestmentAccStart = false"
                    color="#2a579a"
                    no-title
                    :readonly="!editing && isInvestmentAccAdded"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
              <v-spacer />
              <v-flex xs5>
                <v-menu
                  v-model="dateMenuInvestmentAccEnd"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :readonly="!editing && isInvestmentAccAdded"
                >
                  <template :readonly="!editing && isInvestmentAccAdded" v-slot:activator="{ on }">
                    <v-text-field
                      v-model="computedDateInvestmentAccEnd"
                      label="Data zakończenia"
                      :class="{'datepicker--hide': !editing && isInvestmentAccAdded}"
                      prepend-icon="event"
                      :readonly="!editing && isInvestmentAccAdded"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="investmentAcceptance.date_to"
                    @input="dateMenuInvestmentAccEnd = false"
                    color="#2a579a"
                    no-title
                    :readonly="!editing && isInvestmentAccAdded"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12>
                <v-list style="width: 100%">
                  <template v-for="(value, key) in parametersFields">
                    <v-list-tile
                      class="list--el"
                      style="border-bottom: 1px solid lightgrey"
                      :key="key"
                    >
                      <v-list-tile-content
                        @click="investmentAcceptance[key] = !investmentAcceptance[key]"
                      >
                        <v-list-tile-title>{{value}}</v-list-tile-title>
                      </v-list-tile-content>
                      <v-list-tile-action>
                        <v-checkbox
                          class="checkbox--big"
                          :readonly="!editing && isInvestmentAccAdded"
                          v-model="investmentAcceptance[key]"
                        ></v-checkbox>
                      </v-list-tile-action>
                    </v-list-tile>
                  </template>
                </v-list>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12>
                <v-text-field
                  v-model="investmentAcceptance.description"
                  label="Opis"
                  :readonly="!editing && isInvestmentAccAdded"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap v-if="!isInvestmentAccAdded">
              <v-spacer />
              <v-flex xs3>
                <v-btn
                  dark
                  color="#304058"
                  @click="addInvestmentDetail('acceptance_documentation')"
                >DODAJ ODBIÓR</v-btn>
              </v-flex>
              <v-spacer />
            </v-layout>

            <v-layout row v-if="isInvestmentAccAdded">
              <v-flex
                xs12
                v-if="$can('read', 'investments_attachments') || $can('edit', 'investments_attachments')"
              >
                <AddAttachment
                  ref="investmentsAcceptanceAttach"
                  @attachmentAdded="loadAttachments('investments', 'acceptance_documentation')"
                  @attachmentDeleted="loadAttachments('investments', 'acceptance_documentation')"
                  @confDialogOpened="triggerDialogAttach"
                  :id_="investmentData.id"
                  objectType="investments"
                  objectTable="acceptance_documentation"
                  :auto="true"
                  :module="module"
                />
                <v-subheader class="font--primary">Powiązane załączniki</v-subheader>
                <div
                  v-if="allAttachments['acceptance_documentation'].hasOwnProperty('data') && allAttachments['acceptance_documentation'].data.length > 0"
                >
                  <li
                    class="list__container--el"
                    v-for="(index, key) in allAttachments['acceptance_documentation'].data"
                    :key="key"
                  >
                    <span>{{index.id}} - {{index.filename}}</span>
                    <span>
                      <v-icon
                        @click="downloadAttachment(index.id, index.filename, 'investmentsAcceptanceAttach')"
                        small
                        title="Pobierz załącznik"
                        v-if="$can('read', 'investments_attachments') || $can('edit', 'investments_attachments')"
                      >cloud_download</v-icon>
                      <v-icon
                        @click="deleteAttachment(index.id, 'investmentsAcceptanceAttach')"
                        small
                        title="Usuń załącznik"
                        v-if="$can('edit', 'investments_attachments')"
                      >delete</v-icon>
                    </span>
                  </li>
                </div>
                <div v-else>
                  <p class="font--primary">Brak powiązanych załączników</p>
                </div>
              </v-flex>
            </v-layout>
          </span>
          <span v-else>
            <v-layout row wrap>
              <v-spacer />
              <v-flex xs4>
                <v-btn
                  dark
                  color="#304058"
                  @click="hideInvestmentAcc = false"
                  style="margin-top:50px;margin-left:0"
                >ROZPOCZNIJ DODAWANIE</v-btn>
              </v-flex>
              <v-spacer />
            </v-layout>
          </span>
        </v-tab-item>
      </v-tabs>
    </div>
  </Modal>
</template>

<script>
import AddAttachment from "../../../shared/AddAttachment";
import Modal from "../../../shared/Modal";
import Feature from "ol/Feature";

import chain from "lodash/chain";
import value from "lodash/value";
import mixin from "lodash/mixin";
import _ from "lodash/wrapperLodash";
import map from "lodash/map";
import each from "lodash/each";
import some from "lodash/some";
import clone from "lodash/clone";
mixin(_, {
  chain,
  clone,
  map,
  each,
  some
});
_.value = value;
_.prototype.value = value;

export default {
  components: {
    AddAttachment,
    Modal
  },
  data: () => ({
    allAttachments: {
      acceptance_documentation: {},
      applications: {},
      documentation: {},
      localization: {},
      process: {},
      technical_preconditions: {}
    },
    attachmentsArr: [],
    currentTab: undefined,
    dateMenuInvestmentApp: false,
    dateMenuInvestmentPre: false,
    dateMenuInvestmentDoc: false,
    dateMenuInvestmentProc: false,
    dateMenuInvestmentAccStart: false,
    dateMenuInvestmentAccEnd: false,
    editing: false,
    hideInvestmentApp: true,
    hideInvestmentPreconditions: true,
    hideInvestmentDocs: true,
    hideInvestmentProc: true,
    hideInvestmentAcc: true,
    investmentAcceptance: {
      date_from: new Date().toISOString().substr(0, 10),
      date_to: new Date().toISOString().substr(0, 10),
      description: "",
      tightness_test: false,
      video_inspection: false,
      water_test: false
    },
    investmentApplication: {},
    investmentData: {},
    investmentDocumentation: {},
    investmentPrecondition: {},
    investmentProcess: {},
    isDrawing: false,
    isInvestmentAppAdded: false,
    isInvestmentPreAdded: false,
    isInvestmentDocAdded: false,
    isInvestmentProcAdded: false,
    isInvestmentAccAdded: false,
    module: "investments_attachments",
    parametersFields: {
      water_test: "Badania wody",
      tightness_test: "Próba szczelności",
      video_inspection: "Inspekcja wideo",
      land_survey: "Inwentaryzacja geodezyjna",
      survey: "Inwentaryzacja powykonawcza",
      pressure_checked: "Próba ciśnienia"
    },
    statuses: [],
    types: [],

    objects: [],
    objectsCopy: undefined
  }),
  computed: {
    activeModals() {
      return this.$store.getters.getModalsList;
    },
    ifAttachments() {
      return this.$store.getters.getObjectAttachments;
    },
    layersDict() {
      const layers = this.$store.getters.getLayers;
      if (layers.length > 0) {
        const dict = {};
        layers.forEach(({ type, full_name }) => {
          dict[type] = full_name;
        });
        return dict;
      }
      return {};
    },
    computedDateInvestmentApp: {
      get() {
        if (this.investmentApplication.document_date != null) {
          return this.formatDate(
            this.investmentApplication.document_date.slice(0, 10)
          );
        }
      },
      set(value) {
        let splittedDate = value.split(".");
        if (splittedDate.length === 3) {
          this.investmentApplication.document_date = `${splittedDate[2]}-${splittedDate[1]}-${splittedDate[0]}`;
        }
      }
    },
    computedDateInvestmentPre: {
      get() {
        if (this.investmentPrecondition.document_date != null) {
          return this.formatDate(
            this.investmentPrecondition.document_date.slice(0, 10)
          );
        }
      },
      set(value) {
        let splittedDate = value.split(".");
        if (splittedDate.length === 3) {
          this.investmentPrecondition.document_date = `${splittedDate[2]}-${splittedDate[1]}-${splittedDate[0]}`;
        }
      }
    },
    computedDateInvestmentDoc: {
      get() {
        if (this.investmentDocumentation.document_date != null) {
          return this.formatDate(
            this.investmentDocumentation.document_date.slice(0, 10)
          );
        }
      },
      set(value) {
        let splittedDate = value.split(".");
        if (splittedDate.length === 3) {
          this.investmentDocumentation.document_date = `${splittedDate[2]}-${splittedDate[1]}-${splittedDate[0]}`;
        }
      }
    },
    computedDateInvestmentProc: {
      get() {
        if (this.investmentProcess.document_date != null) {
          return this.formatDate(
            this.investmentProcess.document_date.slice(0, 10)
          );
        }
      },
      set(value) {
        let splittedDate = value.split(".");
        if (splittedDate.length === 3) {
          this.investmentProcess.document_date = `${splittedDate[2]}-${splittedDate[1]}-${splittedDate[0]}`;
        }
      }
    },
    computedDateInvestmentAccStart: {
      get() {
        if (this.investmentAcceptance.date_from != null) {
          return this.formatDate(
            this.investmentAcceptance.date_from.slice(0, 10)
          );
        }
      },
      set(value) {
        let splittedDate = value.split(".");
        if (splittedDate.length === 3) {
          this.investmentAcceptance.date_from = `${splittedDate[2]}-${splittedDate[1]}-${splittedDate[0]}`;
        }
      }
    },
    computedDateInvestmentAccEnd: {
      get() {
        if (this.investmentAcceptance.date_to != null) {
          return this.formatDate(
            this.investmentAcceptance.date_to.slice(0, 10)
          );
        }
      },
      set(value) {
        let splittedDate = value.split(".");
        if (splittedDate.length === 3) {
          this.investmentAcceptance.date_to = `${splittedDate[2]}-${splittedDate[1]}-${splittedDate[0]}`;
        }
      }
    },
    map() {
      return this.$store.getters.getMap;
    },
    selectedLayer() {
      return this.map
        .getLayers()
        .item(3)
        .getLayers()
        .item(0);
    },
    wodkanLayers() {
      return this.$store.getters.getLayers;
    }
  },
  watch: {
    currentTab(val) {
      let mapFields = {
        1: this.isInvestmentAppAdded,
        2: this.isInvestmentPreAdded,
        3: this.isInvestmentDocAdded,
        4: this.isInvestmentProcAdded,
        5: this.isInvestmentAccAdded
      };
      if (document.querySelector("#investmentCardModal .editing__buttons")) {
        if (val == 0) {
          document
            .querySelector("#investmentCardModal .editing__buttons")
            .classList.remove("btnNoDisplay");
        } else if (
          (val == 1 && !mapFields[val]) ||
          (val == 2 && !mapFields[val]) ||
          (val == 3 && !mapFields[val]) ||
          (val == 4 && !mapFields[val]) ||
          (val == 5 && !mapFields[val])
        ) {
          document
            .querySelector("#investmentCardModal .editing__buttons")
            .classList.add("btnNoDisplay");
        } else if (
          (val == 1 && mapFields[val]) ||
          (val == 2 && mapFields[val]) ||
          (val == 3 && mapFields[val]) ||
          (val == 4 && mapFields[val]) ||
          (val == 5 && mapFields[val])
        ) {
          document
            .querySelector("#investmentCardModal .editing__buttons")
            .classList.remove("btnNoDisplay");
        }
      }
    }
  },
  methods: {
    addGeometry() {
      this.$root.$emit(
        "showSnackbar",
        "success",
        "Kliknij na mapie, aby narysować obszar"
      );
      this.$root.$emit("addNewArea", this.objectType);
      this.isDrawing = true;
    },
    addInvestmentDetail(detailName) {
      let payloadBody;
      if (detailName == "applications") {
        payloadBody = _.clone(this.investmentApplication);
      } else if (detailName == "technical_preconditions") {
        payloadBody = _.clone(this.investmentPrecondition);
      } else if (detailName == "documentation") {
        payloadBody = _.clone(this.investmentDocumentation);
      } else if (detailName == "process") {
        payloadBody = _.clone(this.investmentProcess);
        payloadBody.objects = _.map(self.objects, object => ({
          object_id: object.object_id,
          object_table: object.object_table,
          object_type: "layers"
        }));
      } else if (detailName == "acceptance_documentation") {
        payloadBody = _.clone(this.investmentAcceptance);
      }

      let payload = {
        oid: this.investmentData.id,
        body: payloadBody,
        parameter: detailName
      };

      this.$store.dispatch("addInvestmentDetail", payload).then(r => {
        if (!r) {
          this.$root.$emit("showSnackbar", "red", `${r}`);
          return;
        }

        if (detailName == "applications") {
          this.isInvestmentAppAdded = true;
        } else if (detailName == "technical_preconditions") {
          this.isInvestmentPreAdded = true;
        } else if (detailName == "documentation") {
          this.isInvestmentDocAdded = true;
        } else if (detailName == "process") {
          this.isInvestmentProcAdded = true;
        } else if (detailName == "acceptance_documentation") {
          this.isInvestmentAccAdded = true;
        }
      });
      document
        .querySelector("#investmentCardModal .editing__buttons")
        .classList.remove("btnNoDisplay");
    },
    assignGeomToInvestment(data) {
      // this.investmentData.geom = data[0];
      this.$set(this.investmentData, "geometry", data[0]);
    },
    cancelEditing() {
      this.editing = false;
      switch (this.currentTab) {
        case 0:
          this.investmentData = Object.assign({}, this.investmentDataCopy);
          break;
        case 1:
          this.investmentApplication = Object.assign(
            {},
            this.investmentApplicationCopy
          );
          break;
        case 2:
          this.investmentPrecondition = Object.assign(
            {},
            this.investmentPreconditionCopy
          );
          break;
        case 3:
          this.investmentDocumentation = Object.assign(
            {},
            this.investmentDocumentationCopy
          );
          break;
        case 4:
          this.investmentProcess = Object.assign(
            {},
            this.investmentProcessCopy
          );
          this.objects = _.clone(this.objectsCopy);
          _.each(this.objects, object => {
            this.$store.commit("addCurrentSelectedFeatures", [
              object.org_feature
            ]); //dodanie do listy zaznaczonych
            this.selectedLayer
              .getSource()
              .addFeature(object.org_feature.__value); //dodanie podświetlania
          });
          break;
        case 5:
          this.investmentAcceptance = Object.assign(
            {},
            this.investmentAcceptanceCopy
          );
      }
      this.$root.$emit("removeMapLayer");
    },
    close() {
      this.editing = false;
      this.hideInvestmentApp = true;
      this.hideInvestmentPreconditions = true;
      this.hideInvestmentDocs = true;
      this.hideInvestmentProc = true;
      this.hideInvestmentAcc = true;
      this.$root.$emit("removeMapLayer");

      this.map.getViewport().style.cursor = "";
      this.$root.$emit("clearSelectionFeatures");
      this.$root.$emit("disableSelectionElement");
      this.objects = [];
      this.objectsCopy = undefined;
    },
    downloadAttachment(attachmentId, attachmentName, refName) {
      this.$refs[refName].downloadAttachment(attachmentId, attachmentName);
    },
    deleteAttachment(attachmentId, refName) {
      this.$refs[refName].deleteAttachment(attachmentId);
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}.${month}.${year}`;
    },
    loadAllAttachments() {
      this.loadAttachments("investments", "applications");
      this.loadAttachments("investments", "technical_preconditions");
      this.loadAttachments("investments", "documentation");
      this.loadAttachments("investments", "process");
      this.loadAttachments("investments", "acceptance_documentation");
    },
    loadAttachments(objectType, objectTable) {
      let payload = {
        object_type: objectType,
        layer: objectTable,
        oid: this.investmentData.id
      };
      this.$store.dispatch("getAttachmentsForObject", payload).then(r => {
        if (r) {
          this.allAttachments[objectTable] = r;
        }
      });
    },
    assignObject(data) {
      this.investmentData = data;
      this.loadData();

      let payloadStatuses = {
        schema: "investments",
        table: "investments",
        column: "status"
      };
      this.$store.dispatch("getDictSTC", payloadStatuses).then(r => {
        this.statuses = r.values;
      });

      let payloadTypes = {
        schema: "investments",
        table: "applications_net_types",
        column: "net_type"
      };
      this.$store.dispatch("getDictSTC", payloadTypes).then(r => {
        this.types = r.values;
      });
    },
    assignTab(tabID) {
      this.currentTab = tabID;
    },
    openObjectCard(object, index) {
      const { object_table, org_feature, object_id } = object;
      this.$root.$emit("featureData", object_table, org_feature, object_id);
    },
    loadData() {
      const self = this;

      this.$store
        .dispatch("getInvestmentApplication", this.investmentData.id)
        .then(r => {
          if (r.status == 200) {
            this.investmentApplication = r.data;
            this.isInvestmentAppAdded = true;
            this.hideInvestmentApp = false;
          } else {
            this.investmentApplication = {};
            this.isInvestmentAppAdded = false;
            this.hideInvestmentApp = true;
          }
        });
      this.$store
        .dispatch("getInvestmentPreconditions", this.investmentData.id)
        .then(r => {
          if (r.status == 200) {
            this.investmentPrecondition = r.data;
            this.isInvestmentPreAdded = true;
            this.hideInvestmentPreconditions = false;
          } else {
            this.investmentPrecondition = {};
            this.isInvestmentPreAdded = false;
            this.hideInvestmentPreconditions = true;
          }
        });
      this.$store
        .dispatch("getInvestmentDocumentation", this.investmentData.id)
        .then(r => {
          if (r.status == 200) {
            this.investmentDocumentation = r.data;
            this.isInvestmentDocAdded = true;
            this.hideInvestmentDocs = false;
          } else {
            this.investmentDocumentation = {};
            this.isInvestmentDocAdded = false;
            this.hideInvestmentDocs = true;
          }
        });
      this.$store
        .dispatch("getInvestmentProcess", this.investmentData.id)
        .then(async r => {
          if (r.status === 200) {
            this.investmentProcess = r.data;
            const objects = self.investmentProcess.objects || [];
            delete this.investmentProcess.objects;

            const promises = objects.map(object =>
              this.$store.dispatch("getFeature", {
                object_table: object.object_table.split("@")[0],
                object_id: object.object_id,
                object_type: "layers",
                srid: this.$root.projection
              })
            );
            const resolvedPromises = await Promise.all(promises);

            this.objects = resolvedPromises.filter(r => r instanceof Feature).map((feature, index) => {
              const preperedFeature = Object.assign({}, objects[index]);
              preperedFeature.org_feature = self.$root.createProxy(feature);

              const layer = _.find(
                this.wodkanLayers,
                layer => layer.full_type === preperedFeature.object_table
              );
              preperedFeature.full_name =
                layer.full_name || preperedFeature.object_table;
              preperedFeature.object_display_id = feature.getId();

              this.$store.commit("addCurrentSelectedFeatures", [
                preperedFeature.org_feature
              ]); //dodanie do listy zaznaczonych
              this.selectedLayer.getSource().addFeature(feature); //dodanie podświetlania
              return preperedFeature;
            });

            this.isInvestmentProcAdded = true;
            this.hideInvestmentProc = false;
          } else {
            this.objects = [];
            this.investmentProcess = {};

            this.isInvestmentProcAdded = false;
            this.hideInvestmentProc = true;
          }
        });
      this.$store
        .dispatch("getInvestmentAcceptance", this.investmentData.id)
        .then(r => {
          if (r.status == 200) {
            this.investmentAcceptance = r.data;
            this.isInvestmentAccAdded = true;
            this.hideInvestmentAcc = false;
          } else {
            this.investmentAcceptance = {};
            this.isInvestmentAccAdded = false;
            this.hideInvestmentAcc = true;
          }
        });
    },
    removeGeometry() {
      this.$root.$emit("removeMapLayer");
      if (this.investmentData) {
        this.investmentData.geometry = undefined;
      }
    },
    parseDate(date) {
      if (!date) return null;

      const [day, month, year] = date.split("-");
      return `${day.padStart(2, "0")}-${month.padStart(2, "0")}-${year}`;
    },
    saveEditing() {
      const self = this;

      const investmentsMap = {
        0: [_.clone(self.investmentData), ""],
        1: [_.clone(self.investmentApplication), "applications"],
        2: [_.clone(self.investmentPrecondition), "technical_preconditions"],
        3: [_.clone(self.investmentDocumentation), "documentation"],
        4: [_.clone(self.investmentProcess), "process"],
        5: [_.clone(self.investmentAcceptance), "acceptance_documentation"]
      };

      if (self.currentTab === 4) {
        //zazanczone obikety w procesie inwestyczyjnym
        investmentsMap[self.currentTab][0].objects = _.map(
          self.objects,
          object => ({
            object_id: object.object_id,
            object_table: object.object_table,
            object_type: "layers"
          })
        );
      }

      const payload = {
        oid: self.investmentData.id,
        body: investmentsMap[self.currentTab][0],
        parameter: investmentsMap[self.currentTab][1]
      };

      if (this.currentTab == 0) {
        let desc = payload.body.description_investment;
        delete payload.body.description_investment;
        payload.body["description"] = desc;
      }

      self.$store.dispatch("editInvestments", payload).then(r => {
        if (!r) {
          self.$root.$emit("showSnackbar", "red", `${r}`);
        } else {
          this.$root.$emit("setInvestmentColor", this.investmentData);
        }
      });

      self.editing = false;
      self.$root.$emit("updateInvestments");
    },
    setCurrentTab(tabId) {
      this.currentTab = tabId;
    },
    show(title) {
      if (this.activeModals.indexOf(title) == -1) {
        this.$store.commit("addModal", title);
        this.$modal.show(title);
      }
    },
    startEditing() {
      this.editing = true;
      switch (this.currentTab) {
        case 0:
          this.investmentDataCopy = Object.assign({}, this.investmentData);
          break;
        case 1:
          this.investmentApplicationCopy = Object.assign(
            {},
            this.investmentApplication
          );
          break;
        case 2:
          this.investmentPreconditionCopy = Object.assign(
            {},
            this.investmentPrecondition
          );
          break;
        case 3:
          this.investmentDocumentationCopy = Object.assign(
            {},
            this.investmentDocumentation
          );
          break;
        case 4:
          this.investmentProcessCopy = Object.assign(
            {},
            this.investmentProcess
          );
          this.objectsCopy = _.clone(this.objects);
          break;
        case 5:
          this.investmentAcceptanceCopy = Object.assign(
            {},
            this.investmentAcceptance
          );
      }
    },
    triggerDialogAttach(val) {
      this.$emit("confDialogOpened", val);
    },
    zoomToInvestmentGeom() {
      this.$root.$emit("zoomToArea", [
        this.investmentData.geometry.coordinates
      ]);
      this.$root.$emit(
        "addMapLayer",
        [
          this.investmentData.geometry,
          this.investmentData.geometry.coordinates
        ],
        "investments"
      );
    },

    selectNewObject() {
      const self = this;

      self.$root.$emit(
        "showSnackbar",
        "#2a579a",
        "Kliknij na mapie, aby wybrać obiekt"
      );
      self.map.getViewport().style.cursor = "crosshair";

      self.$root.$once("selectionElementCallback", featuresLayers => {
        //console.log(featuresLayers);
        _.each(featuresLayers, featuresLayer => {
          //przeleć po warstwach
          const features =
            featuresLayer.features_cluster.length > 0
              ? featuresLayer.features_cluster
              : featuresLayer.features;
          _.each(features, feature => {
            //przeleć po elementach warstwy
            const id = feature.getId();

            if (_.some(self.objects, object => object.object_id === id)) {
              return; //duplicat
            }

            const org_feature = self.$root.createProxy(feature);

            self.objects.push({
              object_id: feature.getId(),
              object_table: featuresLayer.layer.get("full_type"),
              object_type: "layers",
              full_name: featuresLayer.layer.get("full_name"),
              object_display_id: feature.getId(),

              org_feature //orginalny feature do usuwania i zoomu
            });

            self.$store.commit("addCurrentSelectedFeatures", [org_feature]); //dodanie do listy zaznaczonych
            self.selectedLayer.getSource().addFeature(feature); //dodanie podświetlania
          });
        });
        self.$forceUpdate();
        self.map.getViewport().style.cursor = "";
      });
      self.$root.$emit("enableSelectionElement", {
        layerTypes: ["water", "sewer"],
        selected: false,
        multi: false
      });
    },
    removeObject(object, index) {
      this.objects.splice(index, 1);

      this.$store.commit("removeCurrentSelectedFeatures", [object.org_feature]); //usunięcie z listy zaznaczonych
      this.selectedLayer.getSource().removeFeature(object.org_feature.__value); //usunięcie podświetlania
    },
    zoomToObject(object, index) {
      this.$root.$emit("zoomToFeature", object.org_feature.__value, {});
    }
  },
  mounted() {
    this.$root.$on("loadInvestment", this.assignObject);
    this.$root.$on("loadTab", this.assignTab);
    this.$root.$on("newGeomAdded", this.assignGeomToInvestment);
  }
};
</script>



// WEBPACK FOOTER //
// src/components/viewer/management/modals/InvestmentCard.vue